import { Button } from "../Button";
import { useTheme } from "../ThemeToggler/context";
import { THEME } from "../ThemeToggler/theme.types";

export const AppearanceSettings = () => {
  const { theme, setTheme } = useTheme();

  return (
    <div className="space-y-8">
      <div>
        <h3 className="text-lg font-semibold">Appearance</h3>
        <p className="text-sm text-muted-foreground">Choose how Fundy looks for you.</p>
      </div>

      <div className="space-y-3">
        <div className="text-sm font-semibold">Theme</div>
        <div className="flex flex-wrap gap-2">
          <Button
            type="button"
            variant={theme === THEME.light ? "default" : "outline"}
            onClick={() => setTheme(THEME.light)}
          >
            Light
          </Button>
          <Button
            type="button"
            variant={theme === THEME.dark ? "default" : "outline"}
            onClick={() => setTheme(THEME.dark)}
          >
            Dark
          </Button>
          <Button
            type="button"
            variant={theme === THEME.system ? "default" : "outline"}
            onClick={() => setTheme(THEME.system)}
          >
            System
          </Button>
        </div>
      </div>
    </div>
  );
};
